import { Component, OnInit, Input } from '@angular/core';
import { SpotifyService } from '../spotify.service';
import { STORAGE_REDIRECT } from '../constants';
import { Router } from '@angular/router';

@Component({
  selector: 'pv-presave',
  templateUrl: './presave.component.html',
  styleUrls: ['./presave.component.scss']
})
export class PresaveComponent implements OnInit {
  @Input() url_alias: string;

  constructor(
    private router: Router,
    private spotifyService: SpotifyService,
  ) { }

  ngOnInit() { }

  onClick() {
    localStorage.setItem(STORAGE_REDIRECT, this.url_alias)
    let host = 'https://polyvinylrecords.com/api/spotify/redirect';
    if (location.host.includes('localhost')) {
      host = 'http://localhost:3000/api/spotify/redirect'
    } else if (location.host.includes('staging')) {
      host = "https://staging.polyvinylrecords.com/api/spotify/redirect";
    }

    location.href = `https://accounts.spotify.com/authorize?client_id=a290f107105b4e9b94278a0eab1f7686&response_type=code&redirect_uri=${encodeURIComponent(host)}&state=${this.url_alias}&scope=user-library-modify%20user-read-email`
  }

}
